import { CircularProgress } from '@material-ui/core';

const Spinner = ({ fullscreen = false }) => {
    const containerStyle = fullscreen
        ? {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 52, 136, 0.05)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        }
        : {
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 52, 136, 0.05)',
            alignItems: 'center',
        };

    return (
        <div style={containerStyle}>
            <div style={{
                padding: '30px 40px',
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                textAlign: 'center',
                minWidth: 300,
            }}>
                <h2 style={{
                    marginBottom: '20px',
                    fontSize: '18px',
                    fontWeight: 500,
                    color: '#003488'
                }}>
                    Cargando, por favor espere...
                </h2>
                <CircularProgress
                    size={44}
                    thickness={4}
                    style={{ color: '#00ab8e' }}
                />
            </div>
        </div>
    );
};

export default Spinner;